import { RudderAnalytics } from '@rudderstack/analytics-js';
import { RudderTyperAnalytics } from '../types/index';
import { getVisitorId } from '../helpers/cookies';
import { getStageMode } from '../helpers/getStageMode';
import { rudderDataPlaneUrl } from '../constants';
import { getWriteKey } from '../helpers/getWriteKey';
const writeKey = getWriteKey();
const dataPlaneUrl = rudderDataPlaneUrl;
const skipValidation = Boolean(process.env.CI) ||
    Boolean(process.env.SKIP_ENV_VALIDATION) ||
    process.env.npm_lifecycle_event === 'lint' ||
    getStageMode() === 'test';
export async function initRudder() {
    if (!skipValidation && !writeKey) {
        throw new Error('AnalyticsProvider: writeKey is not provided');
    }
    if (!writeKey) {
        // eslint-disable-next-line no-console
        console.warn('[Rudder] Analytics disabled - missing configuration');
        return undefined;
    }
    return new Promise((resolve) => {
        const analytics = new RudderAnalytics();
        analytics.load(writeKey, dataPlaneUrl, {
            sessions: {
                autoTrack: true,
                cutOff: {
                    enabled: true,
                    duration: 12 * 60 * 60 * 1000, // 12h
                },
            },
            storage: {
                entries: {
                    userTraits: {
                        type: 'sessionStorage',
                    },
                },
                type: 'sessionStorage',
            },
            onLoaded: () => {
                const visitorId = getVisitorId();
                if (visitorId) {
                    analytics.setAnonymousId(visitorId);
                }
            },
        });
        analytics.ready(() => {
            RudderTyperAnalytics.setRudderTyperOptions({ analytics });
            // eslint-disable-next-line no-console
            console.log('RudderStack initialized');
            resolve(analytics);
        });
    });
}
